<div class="img-container" *ngIf="imageId" style="height: 100%; width: 100%">
  <img
    class="img-fluid image"
    [src]="
      imagesService.getFileUrl(
        imageId,
        previewDimensions.width,
        previewDimensions.height
      )
    "
    (error)="onImageError($event)"
    alt=""
    [ngStyle]="{ width: dimensions.width, height: dimensions.height }"
  />
  <button
    mat-mini-fab
    *ngIf="showDeleteButton"
    color="warn"
    class="close-button"
    (click)="onDeleteImageClicked()"
    type="button"
    title="Delete image"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
